import Parallax from 'parallax-js';
import Bound from 'bounds.js';

const SELECTORS = {
  scene: '.scene-parallax',
}

export default class SceneParallax {
  constructor () {
    this.isLoaded = false;
  }

  initialize () {
    const t = this;
    this.elems = Array.from( RM.Select.el(SELECTORS.scene) );
    RM.BM(this, ['onAppInit', 'onAppLoaded', 'onAppLoadedEnded', 'onAppResize']);
    this.isInit();
  }

  init () {
    this.bounds = Bound({
      // root: window,
      threshold: 0.2,// 20% of the element should be within the root element (eg: window)
      margins: {
        top: 0,
        // top: -100,
        // top: App.bounds.window_h / -10,// 10% of the window height
        bottom: 0,
        // bottom: -100,
        // bottom: App.bounds.window_h / -10,// 10% of the window height
      },
    });

    this.elems.forEach( item => this.initSceneParallaxForElem(item) );
  }

  initSceneParallaxForElem (elem) {
    const t = this;
    var parallaxInstance = new Parallax(elem);

    this.bounds.watch(elem, (ratio) => {
      // console.log('enter', ratio);
      t.onEnter(elem, parallaxInstance);
    }, (ratio) => {
      // console.log('leave', ratio);
      t.onLeave(elem, parallaxInstance);
    });
  }

  onEnter (elem, parallaxInstance) {
    // console.log('is revealed', elem);
    parallaxInstance.enable();
  }

  onLeave (elem, parallaxInstance) {
    // console.log('is leaving', elem);
    parallaxInstance.disable();
  }

  isInit () {
    this.isLoaded = true;
    App.loadProgress += 1;
    App.checkAppLoaded();
  }

  onAppInit() {
  }

  onAppLoaded() {
  }

  onAppLoadedEnded() {
    this.init();
  }

  onAppResize() {
  }
}
